import copy from 'copy-to-clipboard';



export default function writeToClipboard(content: string) {
	copy(content, {
		format: 'text/plain',
	});
}
